module.exports = __webpack_public_path__ + "media/images/like-empty-ca53825d14e554e51d772d2908553209.png";